export default {
    maxUserAvatarSize: 2 * 1024 * 1024, // 2MB (in bytes)
    maxUploadStreamThumbSize: 2 * 1024 * 1024, // 2MG (in bytes)
};
